"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = inject;
var _StyleXSheet = require("./StyleXSheet");
function inject(ltrRule, priority) {
  let rtlRule = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  _StyleXSheet.styleSheet.insert(ltrRule, priority, rtlRule);
}